import React from "react";
import ReactDOM from "react-dom/client";
import { createHashRouter, RouterProvider } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import { initializeIcons } from "@fluentui/react";
// MSAL removed - now using Django auth service
// import { MsalProvider } from "@azure/msal-react";
// import { AuthenticationResult, EventType, PublicClientApplication } from "@azure/msal-browser";

import "./index.css";

import Chat from "./pages/chat/Chat";
import LayoutWrapper from "./layoutWrapper";
import i18next from "./i18n/config";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/Auth/ProtectedRoute";
// import { msalConfig, useLogin } from "./authConfig";

initializeIcons();

const router = createHashRouter([
    {
        path: "/",
        element: <LayoutWrapper />,
        children: [
            {
                index: true,
                element: (
                    <ProtectedRoute>
                        <Chat />
                    </ProtectedRoute>
                )
            },
            {
                path: "qa",
                lazy: async () => {
                    const { default: Ask } = await import("./pages/ask/Ask");
                    return {
                        Component: () => (
                            <ProtectedRoute>
                                <Ask />
                            </ProtectedRoute>
                        )
                    };
                }
            },
            {
                path: "login",
                lazy: async () => {
                    const { default: Login } = await import("./components/Auth/Login");
                    return { Component: Login };
                }
            },
            // Registration disabled - uncomment if needed in future
            // {
            //     path: "register",
            //     lazy: async () => {
            //         const { default: Register } = await import("./components/Auth/Register");
            //         return { Component: Register };
            //     }
            // },
            {
                path: "*",
                lazy: () => import("./pages/NoPage")
            }
        ]
    }
]);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

// Django auth with AuthProvider
const appTree = (
    <React.StrictMode>
        <I18nextProvider i18n={i18next}>
            <HelmetProvider>
                <AuthProvider>
                    <RouterProvider router={router} />
                </AuthProvider>
            </HelmetProvider>
        </I18nextProvider>
    </React.StrictMode>
);

root.render(appTree);
